
(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter')
    .component('pdfprintereditor', {
      restrict: 'E',
      bindings: {
        pdfprinter: '<?',
        pdfprinterid: '<?'
      },
      template: `
        <pdfprinterform pdfprinter="vm.pdfprinter" parentsave="vm.childsave(pdfprinter)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> pdfprinter erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen pdfprinter wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> pdfprinter konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Pdfprinter', 'Rlog',
        function ($log, Pdfprinter, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.pdfprinter) || !vm.pdfprinter.hasOwnProperty('_id'))
              && angular.isDefined(vm.pdfprinterid)) {
              Pdfprinter.$find(vm.pdfprinterid).$then(function (pdfprinter) {
                vm.pdfprinter = pdfprinter;
              }, function (err) {
                $log.error('pdfprinter not found, id: ', vm.pdfprinterid, err);
                Rlog.error('pdfprinter', 'pdfprintereditor', 'pdfprinter not found', {_id: vm.pdfprinterid});
              });
            }
          };
          
          function childsave(pdfprinter) {
            // vm.pdfprinter = angular.copy(pdfprinter);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in pdfprinter) {
              if (pdfprinter.hasOwnProperty(key)) {
                vm.pdfprinter[key] = pdfprinter[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.pdfprinter.$hasPendingActions()) {
              vm.pdfprinter.$cancel();
              vm.pdfprinter.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of pdfprinter failed: ', err);
                Rlog.error('vcutils.pdfprinter', 'pdfprintereditor', 'Saving of pdfprinter failed: ', {pdfprinterid: vm.pdfprinter._id});
              });
            }
            else {
              vm.pdfprinter.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of pdfprinter failed: ', err);
                Rlog.error('vcutils.pdfprinter', 'pdfprintereditor', 'Saving of pdfprinter failed: ', {pdfprinterid: vm.pdfprinter._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());
